var exports = {
  "kL": "x31de4314--269751--container",
  "Fg": "x31de4314--269751--breadcrumbs-delimiter",
  "QX": "x31de4314--269751--breadcrumbs-link",
};

module.exports = exports;
